import { apiQuery } from "utils/queries";
import { api } from "../restUtil";
import { PricingModel, PurchaseStudentType } from "./model";

type GetPricingModelParams = {
  code: string;
};
export const pricingModelByCodeQuery = apiQuery<PricingModel, GetPricingModelParams>({
  key: "/pricing/model/code/:code",
  queryFn: ({ params }) => api.get<PricingModel>(`/pricing/model/code/${params.code}`),
});

export const fetchSelectedPricingModel = () =>
  api.get<PricingModel | null>("/pricing/model/selected");

export const fetchPricingModelByCode = (code: string) =>
  api.get<PricingModel>(`/pricing/model/code/${code}`);

type AvailablePricingModelsResponse = {
  list: PricingModel[];
  total: number;
};

type AvailablePricingModelsParams = {
  type?: PurchaseStudentType;
} | void;

export const availablePricingModelsQuery = apiQuery<
  PricingModel[],
  AvailablePricingModelsParams
>({
  key: "availablePricingModels",
  queryFn: async ({ params }) => {
    const response = await api.get<AvailablePricingModelsResponse>("/pricing/models");
    return params?.type
      ? response.list.filter(model => model.type === params.type)
      : response.list;
  },
});

type PostPurchaseIntentPayload = {
  idempotency_key: string;
  save_pm?: boolean;
  use_saved_pm?: boolean;
};
type CreatePurchaseIntentResponse = {
  client_secret: string;
  status: string;
};
export async function postPricingModelItemPurchaseIntent(
  id: string,
  payload: PostPurchaseIntentPayload
): Promise<CreatePurchaseIntentResponse> {
  const url = `/pricing/model/item/${id}/intent/purchase`;
  return api.post(url, payload);
}

export function generateIdempotencyKey(): string {
  return crypto.randomUUID().split("-").join("");
}
